import React, { useState, useEffect, useContext } from 'react';
import { Table, Button, Modal, Label, TextInput, Alert } from "flowbite-react";
import ReusableDataTable from '../../../hooks/ReusableDataTable';
import CustomSelectwithText from '../../../hooks/CustomSelectwithText';
import axios from "axios";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import { FaPen } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import Cdelivery_chellan from './Cdelivery_chellan';
import { IoMdDownload } from "react-icons/io";
import { DownloadpdfDC } from '../../../utils/DownloadpdfDC';
import { MdPrint } from "react-icons/md";
import PrintDC from '../../../utils/PrintDC';
import { AuthContext } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { TbCircleLetterRFilled } from "react-icons/tb";
import { FaRectangleList } from "react-icons/fa6";
import RequestActivityModal from '../../../hooks/RequestActivityModal';

function Cutting_dc({ orderid, Sub_Order_id }) {
    const [data, setData] = useState([]);
    const [selectedMarker, setselectedMarker] = useState({});
    const [AddCuttingDc, setAddCuttingDc] = useState(false);
    const [Order, setOrder] = useState({ sizevarientwithquantity: "", buyer_name: "", colour_name: "", style_name: "", orderdate: "", total_piece: 0, cutorderno: "", pono: "", noofbales: "", delivery_date: "" });
    const [Suborder, setSuborder] = useState({ sizevarientwithquantity: "", total_piece: 0 })
    const [Input, setInput] = useState({});
    const today = new Date().toISOString().split('T')[0];
    const [date, setDate] = useState(today);
    const [Marker, setMarker] = useState({});
    const [completeStatusKey, setcompleteStatusKey] = useState(0) //for re render
    const [EditModal, setEditModal] = useState(false);
    const [DeleteModal, setDeleteModal] = useState(false);
    const [available_quantityFlag, setavailable_quantityFlag] = useState(0);
    const [requestModal, setrequestModal] = useState(false);
    const [requestActivityModal, setrequestActivityModal] = useState(false);
    const [requestActivityData, setrequestActivityData] = useState({});
    const { user } = useContext(AuthContext);
    const navigate = useNavigate();
    const role = sessionStorage.getItem('role');
    useEffect(() => {
        if (!user) {
            navigate("/");
        } else {
            fetchorder();
        }
    }, [user, navigate]);
    console.log(user);

    const fetchmarker = async () => {
        try {
            const response = await axios.get("master/size_variants");
            const markerData = response.data;
            setMarker(markerData);
        } catch (error) {
            console.error("Error fetching Marker data:", error);
        }
    };
    const fetchsuborder = async () => {
        try {
            const response = await axios.get(`order/suborders_by_suborder_id_size_variant/${Sub_Order_id}`);
            const SubOrderData = response.data;
            //   setSuborder(SubOrderData);
            setSuborder({
                sizevarientwithquantity: SubOrderData.size_variant_quantity,
                total_piece: SubOrderData.total_piece,
            })

        } catch (error) {
            console.error("Error fetching suborder data:", error);
        }
    };
    const sizevariantOptions = Marker.length > 0 ? Marker
        .filter((item) => Suborder.sizevarientwithquantity[item.size_id] != undefined)
        .map((item) => ({
            value: item.size_id,
            label: item.size
        })) : [];

    const fetchorder = async () => {
        try {
            const response = await axios.get(`order/orders/${orderid}`);
            const OrderData = response.data;
            setOrder({
                orderdate: OrderData.order_date,
                total_piece: OrderData.total_piece,
                cutorderno: OrderData.cut_order_no,
                pono: OrderData.job_no,
                noofbales: OrderData.no_of_bales,
                buyer_name: OrderData.buyer_name,
                colour_name: OrderData.colour_name,
                style_name: OrderData.style_name,
                delivery_date: OrderData.delivery_date,
                sizevarientwithquantity: OrderData.size_variant_quantity,
            });

        } catch (error) {
            console.error("Error fetching order data:", error);
        }
    };

    const fetchavailablequantity = async () => {
        try {
            const response = await axios.get(`cutting_dc/get_available_quantity/${orderid}/${Sub_Order_id}`);
            const availableQuantityData = response.data.available_quantity;
            setselectedMarker(availableQuantityData);
            setavailable_quantityFlag(response.data.success)
        } catch (error) {
            console.error("Error fetching Marker data:", error);
        }
    };


    // Fetch all logs on component mount
    useEffect(() => {
        fetchorder();
        fetchsuborder();
        fetchCutting_Dc();
        fetchmarker();
    }, []);

    const fetchCutting_Dc = async () => {
        try {
            const response = await axios.get(`cutting_dc/cutting_dc/${orderid}/${Sub_Order_id}`);
            const result = response.data;
            const logs = result.logs;
            setData(logs);
        } catch (error) {
            console.error("Error fetching logs:", error);
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const totalPiece = Object.values(selectedMarker)
            .map(Number)
            .reduce((acc, value) => acc + value, 0);

        if (Object.keys(selectedMarker).length === 0) {
            Swal.fire({
                icon: "error",
                text: "Please fill in the size variant quantities ",
                type: "error",
                timer: 2000,
                showConfirmButton: false,
            });

        }
        else if (totalPiece === 0) {
            Swal.fire({
                icon: "error",
                text: "Ensure the total pieces is greater than 0.",
                type: "error",
                timer: 2000,
                showConfirmButton: false,
            });

        }
        else {

            const requestData = {
                ...Input,
                orderdate: date,
                order_id: orderid,
                sub_order_id: Sub_Order_id,
                size_variant_quantity: selectedMarker,
                total_piece: totalPiece,
                staff_id: user.staff_id,
            };

            try {
                axios
                    .post('cutting_dc/cutting_dc', requestData)
                    .then((response) => {
                        if (response.data.success === 1) {
                            Swal.fire({
                                icon: "success",
                                text: "Cutting DC Completed ",
                                type: "success",
                                timer: 2000,
                                showConfirmButton: false,
                            });
                            fetchCutting_Dc();
                            setAddCuttingDc(false);
                            setcompleteStatusKey((prevKey) => prevKey + 1);
                            setavailable_quantityFlag(0);
                        }
                        else if (response.data.success === 2) {
                            Swal.fire({
                                icon: "error",
                                text: "Quantity  exceeds the allowed limit....",
                                type: "error",
                                timer: 2000,
                                showConfirmButton: false,
                            });

                        }
                        else if (response.data.success === 3) {
                            Swal.fire({
                                icon: "error",
                                text: "The Ready to Sewing section has not been completed.",
                                type: "error",
                                timer: 2000,
                                showConfirmButton: false,
                            });
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                text: "Server Problem. Please Try Again...",
                                type: "error",
                                timer: 2000,
                                showConfirmButton: false,
                            });
                        }
                        return;
                    });
            } catch (error) {
                throw error;
            }
        }
    };


    const handleUpdate = async () => {
        const totalPiece = Object.values(selectedMarker)
            .map(Number)
            .reduce((acc, value) => acc + value, 0);
        if (Object.keys(selectedMarker).length === 0 || totalPiece === 0) {
            Swal.fire({
                icon: "error",
                text: "Please fill in the size variant quantities and ensure total pieces is greater than 0.",
                type: "error",
                timer: 2000,
                showConfirmButton: false,
            });

        }
        else {

            try {
                axios
                    .put(`cutting_dc/cutting_dc/${Input.id}`, {
                        "date": Input.date,
                        "markerwithquantity": selectedMarker,
                        "totalpiece": totalPiece,
                        "remark": Input.remark
                    })
                    .then((response) => {
                        if (response.data.success === 1) {
                            Swal.fire({
                                icon: "success",
                                text: "Updated successfully!",
                                type: "success",
                                timer: 2000,
                                showConfirmButton: false,
                            });
                            fetchCutting_Dc();
                            setEditModal(false);
                            setInput({});
                            setcompleteStatusKey((prevKey) => prevKey + 1);
                        }
                        else if (response.data.success === 2) {
                            Swal.fire({
                                icon: "error",
                                text: "Quantity  exceeds the allowed limit....",
                                type: "error",
                                timer: 2000,
                                showConfirmButton: false,
                            });

                        }
                        else if (response.data.success === 3) {
                            Swal.fire({
                                icon: "error",
                                text: "The ready to sewing section has not been completed.",
                                type: "error",
                                timer: 2000,
                                showConfirmButton: false,
                            });
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                text: "Server Problem. Please Try Again...",
                                type: "error",
                                timer: 2000,
                                showConfirmButton: false,
                            });
                        }
                        return;
                    });
            } catch (error) {
                throw error;
            }
        }
    };

    const handleDelete = async () => {
        try {
            axios.delete(`cutting_dc/cutting_dc/${Input.id}`).then((res) => {
                if (res.data.success === 1) {
                    Swal.fire({
                        icon: "success",
                        text: "Cutting Issue  deleted",
                        type: "success",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                    fetchCutting_Dc();
                    setDeleteModal(false);
                    setcompleteStatusKey((prevKey) => prevKey + 1);
                } else {
                    Swal.fire({
                        icon: "error",
                        text: "Server Problem. Please Try Again...",
                        type: "error",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                }
                return;
            });
        } catch (error) {
            throw error;
        }
    };

    // Handle input change
    const onChangeValue = (e) => {
    const { name, value } = e.target;
    setInput({ ...Input, [name]: value });

    if (name === "date") {
        setDate(value);
    }
};


    const fetchrequestActivity = async (Id) => {
        try {
            const response = await axios.get(`/requests/request/${Id}`, {
                params: { section_name: 'Cutting DC' },
            });
            const requestActivityData = response.data.data;
            console.log(requestActivityData)
            setrequestActivityData(requestActivityData);
        } catch (error) {
            console.error("Error fetching requestActivityData:", error);
        }
    };
    //  Add Request
    const handleRequest = async (e) => {
        e.preventDefault();

        setrequestModal(false)
        const requestData = {
            ...Input,
            order_id: orderid,
            sub_order_id: Sub_Order_id,
            staff_id: user.staff_id,
            section_name: 'Cutting DC',
            section_id: Input.id,
            reason: Input.reason
        };


        try {
            axios
                .post('cutting_dc/cutting_dc/request', requestData)
                .then((response) => {
                    if (response.data.success === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Requested",
                            type: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        fetchCutting_Dc();
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            text: "Server Problem. Please Try Again...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }
                    return;
                });
        } catch (error) {
            throw error;
        }
    };

    const columns = [
        { name: "#", selector: (row) => row.id, sortable: true },
        { name: "Selected Date", selector: (row) => row.date, sortable: true },
        { name: "Staff Name", selector: (row) => row.staffname, sortable: true },
        { name: "Size with quantity", selector: (row) => row.markerwithquantity, sortable: true },
        { name: "Total Piece", selector: (row) => row.totalpiece, sortable: true },
        { name: "Remark", selector: (row) => row.remark, sortable: true },
        {
            name: "Created at",
            selector: (row) => {
                const date = new Date(row.datetime);
                return [`${date.toLocaleDateString("en-GB")}`, `${date.toLocaleTimeString("en-GB", { hour12: false })}`];
            },
            sortable: true,
            cell: (row) => (
                <div>
                    <div>{new Date(row.datetime).toLocaleDateString("en-GB")}</div>
                    <div>{new Date(row.datetime).toLocaleTimeString("en-GB", { hour12: false })}</div>
                </div>
            )
        },
        ...(role === 'Cutting_Staff' || role === 'super_admin' || role === 'FM' ? [{ name: "Option", selector: (row) => row.option, grow: 2 }]
            : [])

    ];


    const Data = data?.map((plan, index) => {
        const currentDate = new Date().toLocaleDateString('en-GB');
        const planDate = new Date(plan.datatime).toLocaleDateString('en-GB');
        return {
            sno: index + 1,
            id: plan.cutting_dc_log_id,
            date: new Date(plan.date).toLocaleDateString('en-GB'),
            formatedmarkerwithquantity: plan.formated_size_variant,
            markerwithquantity: plan.formated_size_variant,
            totalpiece: plan.total_piece,
            remark: plan.remark,
            datetime: plan.datatime,
            staffname: plan.staff_name,
            option: (
                <div style={{ display: "flex" }}>
                    {
                        (role === 'super_admin' || ((role === 'Cutting_Staff' || role === 'FM') &&
                            currentDate === planDate) || ((role === 'FM' && plan.request_status == 'accepted'))) && (
                            <>
                                <FaPen
                                    className="text-amber-400 text-xl cursor-pointer"
                                    onClick={() => {
                                        setInput({
                                            id: plan.cutting_dc_log_id,
                                            date: new Date(plan.date).toISOString().split('T')[0],
                                            markerwithquantity: plan.size_variant_quantity,
                                            totalpiece: plan.total_piece,
                                            remark: plan.remark,
                                        });
                                        setselectedMarker(plan.size_variant_quantity)
                                        setEditModal(true);
                                    }}
                                />
                                <MdDeleteForever
                                    className="ml-2 text-red-500 text-2xl"
                                    onClick={() => {
                                        setInput({ id: plan.cutting_dc_log_id });

                                        setDeleteModal(true);
                                    }}
                                />
                            </>
                        )}
                    {(role === 'FM' && currentDate !== planDate && plan.request_status != 'accepted') && (

                        <TbCircleLetterRFilled
                            className="text-green-500 text-xl "
                            onClick={() => {
                                // handleRequest(plan.rts_log_id)
                                (plan.request_status == 'request' || plan.request_status == "rejected") && setrequestModal(true); setInput({ id: plan.cutting_dc_log_id });
                            }}
                            style={{
                                color: plan.request_status == 'requested' ? "grey" : "green",
                                cursor: plan.request_status == 'requested' ? "not-allowed" : "pointer",
                            }}
                        />
                    )}
                    {(role === 'FM' || role === 'super_admin') &&
                        <FaRectangleList
                            className="pl-1 text-blue-500 text-2xl"
                            onClick={() => {
                                fetchrequestActivity(plan.cutting_dc_log_id);
                                setrequestActivityModal(true);

                            }}
                        />}
                    <IoMdDownload
                        className="ml-2 text-indigo-600 text-2xl cursor-pointer"
                        onClick={() =>
                            DownloadpdfDC(
                                "Cutting DC",
                                ["Date", "Size And Quantity", "Total Piece", "Remark"],
                                [[
                                    `${new Date(plan.datatime).toLocaleDateString("en-GB")}\n${new Date(plan.datatime).toLocaleTimeString("en-GB", { hour12: true })}`,
                                    plan.formated_size_variant,
                                    plan.total_piece,
                                    plan.remark
                                ]]
                            )
                        }
                    />

                    <MdPrint
                        className="ml-2 text-green-600 text-2xl cursor-pointer"
                        onClick={() =>
                            PrintDC(
                                "Cutting DC",
                                ["Date & Time", "Size And Quantity", "Total Piece", "Remark"],
                                [[
                                    `${new Date(plan.datatime).toLocaleDateString("en-GB")}\n${new Date(plan.datatime).toLocaleTimeString("en-GB", { hour12: true })}`,
                                    plan.formated_size_variant,
                                    plan.total_piece,
                                    plan.remark
                                ]]
                            )

                        }
                    />


                </div>
            )


        };
    }) || [];

    return (
        <>
            {(role === 'Cutting_Staff' || role === 'super_admin' || role === 'FM') &&
                <Button className="bg-icon-color text-sidebar-color drop-shadow-md font-bold" onClick={() => { setAddCuttingDc(true); fetchavailablequantity(); }}>
                    Add Cutting Issue
                </Button>}

            <Cdelivery_chellan key={completeStatusKey} orderid={orderid} Sub_Order_id={Sub_Order_id} />

            <div className="overflow-x-auto mt-2">
                <ReusableDataTable columns={columns} data={Data} />
            </div>

            <Modal show={AddCuttingDc} size="md" onClose={() => { setAddCuttingDc(false);setDate(today); setselectedMarker({}); }} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="space-y-6">
                        <h3 className="text-xl font-medium text-gray-900 dark:text-white">Add Cutting Issue</h3>
                        {available_quantityFlag === 1 && (
                            <Alert color="failure" className="mt-2">
                                Ready to Sewing section has not completed
                            </Alert>
                        )}

                        {available_quantityFlag === 2 && (
                            <Alert color="failure" className="mt-2">
                                Unable to add. The Ready to Sewing quantity has already been fully transferred to cutting Issue.
                            </Alert>
                        )}
                        {available_quantityFlag !== 1 && available_quantityFlag !== 2 && (
                            <>
                                <form onSubmit={handleSubmit}>
                                    <div className='pt-2'>
                                        <Label htmlFor="orderdate" value="Date" />
                                        <TextInput name="date" type="date" required autoComplete="off" onChange={onChangeValue} value={date} // set default value
                                            min={sessionStorage.getItem("role") === "super_admin" ? "" : today}
                                            max={today}
                                        />
                                    </div>

                                    <div className='pt-2'>
                                        <Label htmlFor="sizeVariant" value="Size with quantity" />
                                        <CustomSelectwithText
                                            value={selectedMarker}
                                            onChange={(selectedOptions) => setselectedMarker(selectedOptions)}
                                            options={sizevariantOptions}
                                            id="size-variant-select"
                                            name="sizeVariant"
                                        />
                                    </div>

                                    <div className='pt-2'>
                                        <Label htmlFor="remark" value="Remark" />
                                        <TextInput name="remark" type="text" autoComplete="off" onChange={onChangeValue} />
                                    </div>

                                    <div className="pt-3 w-full flex justify-center">
                                        <Button className="bg-icon-color text-sidebar-color drop-shadow-md font-bold" type="submit">Submit</Button>
                                        <Button className="ml-2" color="gray" onClick={() => { setAddCuttingDc(false); setselectedMarker({}); }}>Cancel</Button>
                                    </div>
                                </form>
                            </>)}
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={EditModal} size="md" onClose={() => setEditModal(false)} popup>
                <Modal.Header />
                <Modal.Body>
                    <form onSubmit={(e) => { e.preventDefault(); handleUpdate(); }}>
                        <div className="space-y-6">
                            <h3 className="text-xl font-medium text-gray-900">Update Cutting Issue</h3>

                            <div className="pt-2">
                                <Label htmlFor="date" value="Date" />
                                <TextInput
                                    name="date"
                                    type="date"
                                    value={Input.date} // set default value
                                    min={sessionStorage.getItem("role") === "super_admin" ? "" : today}
                                    max={today}
                                    required
                                    onChange={onChangeValue}
                                />
                            </div>

                            <div className='pt-2'>
                                <Label htmlFor="sizeVariant" value="Size with quantity" />
                                <CustomSelectwithText
                                    value={selectedMarker}
                                    onChange={(selectedOptions) => setselectedMarker(selectedOptions)}
                                    options={sizevariantOptions}
                                    id="size-variant-select"
                                    name="sizeVariant"
                                />
                            </div>

                            <div className="pt-2">
                                <Label htmlFor="remark" value="Remark" />
                                <TextInput
                                    name="remark"
                                    type="text"
                                    value={Input.remark || ''}
                                    // required
                                    onChange={onChangeValue}
                                />
                            </div>

                            <div className="mt-2 flex justify-center">
                                <Button className="bg-icon-color text-sidebar-color drop-shadow-md font-bold" type="submit">Submit</Button>
                                <Button color="gray" className="ml-2" onClick={() => setEditModal(false)}>
                                    Cancel
                                </Button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

            <Modal show={DeleteModal} size="md" onClose={() => setDeleteModal(false)} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="text-center">
                        <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400" />
                        <h3 className="mb-5 text-lg font-normal text-gray-500">
                            Are you sure you want to delete this Cutting Issue?
                        </h3>
                        <div className="flex justify-center gap-4">
                            <Button color="failure" onClick={() => handleDelete()}>
                                Yes
                            </Button>
                            <Button color="gray" onClick={() => setDeleteModal(false)}>
                                No
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                show={requestModal}
                size="md"
                onClose={() => setrequestModal(false)}
                popup
            >
                <Modal.Header />
                <Modal.Body>
                    <div className="text-center">
                        <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                            Are you sure you want to request admin access for editing?
                        </h3>

                    </div>
                    <div className="space-y-6">

                        <form>
                            <div>
                                <div className="pt-2 text-left mb-2 block">
                                    <Label htmlFor="completed-date" value="Reason" />
                                </div>
                                <TextInput
                                    id="reason"
                                    name="reason"
                                    type="text"
                                    required
                                    autoComplete="off"
                                    onChange={onChangeValue}
                                />
                            </div>

                            <div className="pt-3 w-full flex justify-center">
                                <Button className="bg-icon-color text-sidebar-color drop-shadow-md font-bold" type="submit" onClick={(e) => handleRequest(e)}>
                                    Yes
                                </Button>
                                <Button className="ml-2" color="gray" onClick={() => setrequestModal(false)}>
                                    No
                                </Button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            <RequestActivityModal
                show={requestActivityModal}
                onClose={() => setrequestActivityModal(false)}
                requestActivityData={requestActivityData}
            />
        </>
    );
}

export default Cutting_dc;
